<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} ITEM
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- NAME -->
        <div class="flex items-center">
          <vs-input
            label="Version"
            v-model="dataVersion"
            class="mt-5 w-full"
            name="item-v"
            v-validate="'required'"
          />
          
          <span class="text-danger text-sm" v-show="errors.has('item-v')">{{
            errors.first("item-v")
          }}</span>
            <span v-if="theme != 'brisk'">
              <vs-input
              label="Framework old V"
              v-model="dataFramework.before"
              class="mt-5 w-full ml-4"
              name="item-v"
              v-validate="'required'"
            />
              <vs-input
              label="Framework new V"
              v-model="dataFramework.after"
              class="mt-5 w-full ml-4"
              name="item-v"
              v-validate="'required'"
            />
          </span>
        </div>
        <!-- NAME -->
         <vs-input
          label="Date"
          v-model="dataDate"
          class="mt-2 mb-2"
          name="item-date"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('item-d')">{{
          errors.first("item-d")
        }}</span>

        <p class="mt-5"><b>Changes</b>
         <span style="color:blue; margin-right:5px" @click="copy">Copy</span>
         <span style="color:blue" @click="paste">Paste</span>
         </p>

        <div
          class="flex items-center"
          v-for="(change, index) in dataChanges"
          :key="index"
        >
          <vs-select
            v-model="change.type"
            label="Type"
            class="mb-1 w-full"
            name="change-category"
            style="max-width: 120px; margin-right: 15px"
          >
            <vs-select-item
              :key="item.value"
              :value="item.value"
              :text="item.text"
              v-for="item in category_choices"
            />
          </vs-select>
          <vs-input
            label="Info"
            v-model="dataChanges[index].info"
            class="mb-1 w-full"
            name="item-info"
            v-validate="'required'"
          />
        </div>
        <vs-button
          size="small"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          class="mt-1"
          @click="addChange"
          >Add</vs-button
        >
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        class="mt-2"
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from "vuejs-datepicker";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    theme:{
      type: String
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { id, img, name, category, link, v } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.dataId = id;
        this.dataCategory = category;
        this.dataImg = img;
        this.dataName = name;
        this.dataVersion = v;
        this.dataLink = link;
        this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.version, this.dataStat } = JSON.parse(JSON.stringify(this.data))
    },
  },
  data() {
    return {
      dataId: null,
      dataFramework: {before:"",after:""},
      dataVersion: "",
      dataDate: '',
      lastV: '',
      dataChanges: [
        {
          type: "",
          info: "",
        },
      ],

      category_choices: [
        { text: "new", value: "new" },
        { text: "fix", value: "fix" },
        { text: "upd", value: "upd" },
        { text: "title", value: "title" },
      ],

      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.$validator.reset()
          this.initValues()
        }
      },
    },
    isFormValid() {
      return !this.errors.any() && this.dataVersion && this.dataDate;
    },
  },
  methods: {
    addChange() {
      this.dataChanges.push({
        type: "",
        info: "",
      });
    },
    copy() {
       navigator.clipboard.writeText( JSON.stringify(this.dataChanges) );
       console.log(this.dataChanges)
    },
    paste() {
      let _this = this;
      navigator.clipboard.readText().then(
        clipText => _this.dataChanges = JSON.parse(clipText)
      );
    },
    initValues() {
      var date = new Date
      date = date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
      
      var lastV = this.$store.state.changelogList.products;
      lastV = lastV[lastV.length - 1];
      this.lastV = lastV.tag.version;

      if (this.data.id) return;
      this.dataFramework = {before:"",after:""},
      this.dataId = null;
      this.dataVersion = this.lastV;
      this.dataDate = date;
      this.dataChanges = [
        {
          type: "",
          info: "",
        },
      ];
    },
    submitData() {
      
      this.$validator.validateAll().then((result) => {
        if (result) {
          const obj = {
            id: this.dataId,
            framework: this.dataFramework,
            version: this.dataVersion,
            date: this.dataDate.toUpperCase(),
            changes: this.dataChanges,
            theme: this.theme || 'framey',
            versionOld:this.lastV
          };
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch("pagesList/updateItem", obj).catch((err) => {
              console.error(err);
            });
          } else {
            delete obj.id;
            this.$store.dispatch("changelogList/addItem", obj).catch((err) => {
              console.error(err);
            });
            console.log(obj);
          }
          this.$emit("closeSidebar");
          setTimeout(() => {
            this.initValues();
          }, 1000);
        }
      });
    },
  },
  components: {
    VuePerfectScrollbar,
    Datepicker,
  },
  updated() {},
  mounted() {
    console.log(this.theme)
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 450px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
